import { Pagination } from '../types/Pagination';
import { ToastersService } from '../services/toasters.service';

export abstract class AbstractComponentWithPagination<T> {
  list: T[] = [];
  isLoading = false;
  canLoadMore = true;

  protected constructor(private readonly listName: string, protected toasters: ToastersService) {}

  abstract fetchNextPage(pagination: Pagination): Promise<T[]>;

  async onLoadMore(pagination: Pagination) {
    try {
      this.isLoading = true;
      this.canLoadMore = false;
      const nextPageOfItems = await this.fetchNextPage(pagination);
      this.list.push(...nextPageOfItems);
      this.canLoadMore = nextPageOfItems.length >= pagination.perPage;
    } catch (e) {
      this.toasters.createErrorToast(`Error loading more ${this.listName}`);
    } finally {
      this.isLoading = false;
    }
  }
}
